import { FC, useRef } from "react";
import Lottie from 'react-lottie';
import ic_edit from "./../../assets/lottie/configure.json"

const DEFAULT_COLOR = "white";
interface IIcon extends React.ButtonHTMLAttributes<HTMLImageElement> {
  fill?: string;
  isSelected?: boolean;
}

const IconClose: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" width="17.735" height="17.736" viewBox="0 0 17.735 17.736">
    <g id="Raggruppa_978" data-name="Raggruppa 978" transform="translate(-907.83 -151.331)">
      <path id="Tracciato_961" data-name="Tracciato 961" d="M8903.3,2235.8l17.028,17.029" transform="translate(-7995.119 -2084.119)" fill="none" stroke={fill || DEFAULT_COLOR} strokeWidth="1"/>
      <path id="Tracciato_962" data-name="Tracciato 962" d="M8903.3,2235.8l6.684,6.684" transform="translate(3161.014 -8751.616) rotate(90)" fill="none" stroke={fill || DEFAULT_COLOR} strokeWidth="1"/>
      <path id="Tracciato_963" data-name="Tracciato 963" d="M8903.3,2235.8l6.527,6.528" transform="translate(3150.515 -8741.116) rotate(90)" fill="none" stroke={fill || DEFAULT_COLOR} strokeWidth="1"/>
    </g>
    </svg>

  );
};
const IconCloseMenu: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M6.25 10.4167V39.5833C6.25 41.875 8.125 43.75 10.4167 43.75H39.5833C41.875 43.75 43.75 41.875 43.75 39.5833V10.4167C43.75 8.125 41.875 6.25 39.5833 6.25H10.4167C8.125 6.25 6.25 8.125 6.25 10.4167ZM33.9583 33.9375C33.1458 34.75 31.8333 34.75 31.0208 33.9375L25 27.9375L18.9792 33.9583C18.1667 34.7708 16.8542 34.7708 16.0417 33.9583C15.2292 33.1458 15.2292 31.8333 16.0417 31.0208L22.0625 25L16.0417 18.9792C15.2292 18.1667 15.2292 16.8542 16.0417 16.0417C16.8542 15.2292 18.1667 15.2292 18.9792 16.0417L25 22.0625L31.0208 16.0625C31.8333 15.25 33.1458 15.25 33.9583 16.0625C34.7708 16.875 34.7708 18.1875 33.9583 19L27.9375 25L33.9583 31C34.75 31.8125 34.75 33.1458 33.9583 33.9375Z"
      />
    </svg>
  );
};
const IconDomotica: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M31.25 18.75H18.75C17.6042 18.75 16.6667 19.6875 16.6667 20.8333V45.8333C16.6667 46.9792 17.6042 47.9167 18.75 47.9167H31.25C32.3959 47.9167 33.3334 46.9792 33.3334 45.8333V20.8333C33.3334 19.6875 32.3959 18.75 31.25 18.75ZM25 29.6875C23.5625 29.6875 22.3959 28.5208 22.3959 27.0833C22.3959 25.6458 23.5625 24.4792 25 24.4792C26.4375 24.4792 27.6042 25.6458 27.6042 27.0833C27.6042 28.5208 26.4375 29.6875 25 29.6875Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M16.2917 14.2084C17.0209 14.9375 18.1667 15 19 14.4167C20.6875 13.2084 22.7709 12.5 25 12.5C27.2292 12.5 29.3125 13.2084 31 14.3959C31.8334 14.9792 32.9792 14.9375 33.7084 14.2084C34.6042 13.3125 34.5209 11.8125 33.5209 11.0834C31.125 9.35421 28.1875 8.33337 25 8.33337C21.8125 8.33337 18.875 9.35421 16.4792 11.0834C15.4584 11.8125 15.3959 13.3125 16.2917 14.2084Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M25 0C19.5 0 14.4584 1.9375 10.5209 5.14583C9.56252 5.9375 9.47919 7.375 10.3542 8.25C11.1042 9 12.2917 9.0625 13.1042 8.39583C16.3334 5.77083 20.4792 4.16667 25 4.16667C29.5209 4.16667 33.6667 5.77083 36.875 8.41667C37.6875 9.08333 38.875 9.02083 39.625 8.27083C40.5 7.39583 40.4167 5.95833 39.4584 5.16667C35.5417 1.9375 30.5 0 25 0Z"
      />
    </svg>
  );
};
const IconEdit: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  const ref:any = useRef();
  const defaultOptions = {
    loop: false,
    autoplay: false, 
    animationData: ic_edit,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div  onMouseEnter={() => {
      //@ts-ignore
      ref?.current?.play()
    }} onMouseLeave={() => {
      //@ts-ignore
      ref?.current?.stop()
    }}>
      <Lottie  ref={ref} options={defaultOptions} height={40} width={40}  
      isStopped={true}
      />
    </div>
  );
};
const IconFacebook: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.3831 18.056H34.4132L33.9228 24.1914H27.383V45.5078H19.1226V24.1913H14.7139V18.0559H19.1226V13.9324C19.1226 12.1184 19.1704 9.31367 20.5421 7.57705C21.9875 5.74092 23.9726 4.49219 27.3831 4.49219C32.942 4.49219 35.2859 5.25303 35.2859 5.25303L34.1834 11.5371C34.1834 11.5371 32.3473 11.0259 30.6326 11.0259C28.9182 11.0259 27.3832 11.6146 27.3832 13.2651V18.056H27.3831Z"
      />
    </svg>
  );
};
const IconFrecciaDx: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M19.3542 33.0833L27.4375 25L19.3542 16.9166C18.5417 16.1041 18.5417 14.7916 19.3542 13.9791C20.1667 13.1666 21.4792 13.1666 22.2917 13.9791L31.8542 23.5416C32.6667 24.3541 32.6667 25.6666 31.8542 26.4791L22.2917 36.0416C21.4792 36.8541 20.1667 36.8541 19.3542 36.0416C18.5625 35.2291 18.5417 33.8958 19.3542 33.0833Z"
      />
    </svg>
  );
};
const IconFrecciaDown: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M16.9167 19.3542L25 27.4376L33.0833 19.3542C33.8958 18.5417 35.2083 18.5417 36.0208 19.3542C36.8333 20.1667 36.8333 21.4792 36.0208 22.2917L26.4583 31.8542C25.6458 32.6667 24.3333 32.6667 23.5208 31.8542L13.9583 22.2917C13.1458 21.4792 13.1458 20.1667 13.9583 19.3542C14.7708 18.5626 16.1042 18.5417 16.9167 19.3542Z"
      />
    </svg>
  );
};
const IconFrecciaDownNext: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M10.9393 21.0607C11.5251 21.6464 12.4749 21.6464 13.0607 21.0607L22.6066 11.5147C23.1924 10.9289 23.1924 9.97919 22.6066 9.3934C22.0208 8.80761 21.0711 8.80761 20.4853 9.3934L12 17.8787L3.51472 9.3934C2.92893 8.80761 1.97918 8.80761 1.3934 9.3934C0.807611 9.97918 0.807611 10.9289 1.3934 11.5147L10.9393 21.0607ZM10.5 -6.55671e-08L10.5 20L13.5 20L13.5 6.55671e-08L10.5 -6.55671e-08Z"
      />
    </svg>
  );
};
const IconFrecciaUp: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M16.9167 30.6458L25 22.5624L33.0833 30.6458C33.8958 31.4583 35.2083 31.4583 36.0208 30.6458C36.8333 29.8333 36.8333 28.5208 36.0208 27.7083L26.4583 18.1458C25.6458 17.3333 24.3333 17.3333 23.5208 18.1458L13.9583 27.7083C13.1458 28.5208 13.1458 29.8333 13.9583 30.6458C14.7708 31.4374 16.1042 31.4583 16.9167 30.6458Z"
      />
    </svg>
  );
};
const IconFrecciaSx: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M30.6458 33.0833L22.5625 25L30.6458 16.9166C31.4583 16.1041 31.4583 14.7916 30.6458 13.9791C29.8333 13.1666 28.5208 13.1666 27.7083 13.9791L18.1458 23.5416C17.3333 24.3541 17.3333 25.6666 18.1458 26.4791L27.7083 36.0416C28.5208 36.8541 29.8333 36.8541 30.6458 36.0416C31.4375 35.2291 31.4583 33.8958 30.6458 33.0833Z"
      />
    </svg>
  );
};
const IconInstagram: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M40.8117 11.9371C40.8118 12.5093 40.6422 13.0687 40.3244 13.5445C40.0066 14.0203 39.5548 14.3912 39.0261 14.6103C38.4975 14.8293 37.9158 14.8866 37.3546 14.775C36.7934 14.6634 36.2779 14.3879 35.8732 13.9833C35.4686 13.5787 35.1931 13.0632 35.0815 12.5019C34.9699 11.9407 35.0272 11.359 35.2463 10.8304C35.4653 10.3018 35.8362 9.84997 36.312 9.53214C36.7878 9.21432 37.3472 9.04474 37.9194 9.04486C38.6864 9.04501 39.422 9.34979 39.9644 9.89216C40.5067 10.4345 40.8115 11.1701 40.8117 11.9371ZM50 24.999L49.9994 25.0355L49.8351 35.5241C49.7924 39.306 48.2711 42.9209 45.5968 45.5953C42.9224 48.2697 39.3075 49.791 35.5256 49.8337L25 49.999L24.9636 49.9983L14.4749 49.8345C10.6929 49.7918 7.07793 48.2705 4.40346 45.5962C1.72899 42.9218 0.207516 39.3069 0.164643 35.525L0 24.999L0.000714347 24.9626L0.164524 14.4735C0.207519 10.6916 1.72903 7.07678 4.40347 4.40247C7.07792 1.72816 10.6929 0.20683 14.4748 0.164024L25 -0.000976562L25.0364 -0.000262215L35.5251 0.163547C39.307 0.206357 42.9218 1.72771 45.5961 4.40204C48.2705 7.07637 49.7918 10.6912 49.8346 14.4731L50 24.999ZM45.3438 24.999L45.1802 14.5466C45.1512 11.9757 44.117 9.51817 42.2989 7.70008C40.4808 5.88199 38.0234 4.84774 35.4524 4.81867L25 4.65545L14.5476 4.81867C11.9766 4.8478 9.51916 5.88206 7.70107 7.70013C5.88298 9.5182 4.84869 11.9757 4.81952 14.5466L4.65631 24.999L4.81952 35.4514C4.8486 38.0224 5.88286 40.4799 7.70097 42.298C9.51908 44.1161 11.9766 45.1503 14.5476 45.1794L25 45.3426L35.4524 45.1794C38.0234 45.1504 40.4809 44.1162 42.299 42.2981C44.1171 40.48 45.1513 38.0224 45.1802 35.4514L45.3438 24.999ZM37.8381 24.999C37.8381 27.5382 37.0851 30.0203 35.6745 32.1316C34.2638 34.2428 32.2587 35.8883 29.9128 36.86C27.5669 37.8317 24.9856 38.0859 22.4952 37.5905C20.0049 37.0952 17.7173 35.8724 15.9219 34.077C14.1264 32.2815 12.9037 29.9939 12.4083 27.5036C11.913 25.0132 12.1672 22.4318 13.139 20.086C14.1107 17.7401 15.7562 15.735 17.8674 14.3244C19.9787 12.9137 22.4608 12.1608 25 12.1608C28.4037 12.1647 31.6669 13.5185 34.0737 15.9253C36.4805 18.3321 37.8343 21.5953 37.8381 24.999ZM33.1825 24.999C33.1825 23.3806 32.7026 21.7986 31.8035 20.453C30.9044 19.1074 29.6264 18.0586 28.1312 17.4393C26.636 16.8199 24.9908 16.6579 23.4035 16.9736C21.8162 17.2894 20.3582 18.0687 19.2139 19.2131C18.0695 20.3575 17.2902 21.8155 16.9745 23.4027C16.6588 24.99 16.8208 26.6353 17.4402 28.1305C18.0595 29.6256 19.1083 30.9036 20.4539 31.8027C21.7996 32.7018 23.3816 33.1817 25 33.1816C27.1694 33.1791 29.2492 32.3162 30.7831 30.7822C32.3171 29.2482 33.1799 27.1684 33.1824 24.999H33.1825Z"
      />
    </svg>
  );
};
const IconLinkedin: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M5.0123 18.1495H13.8024V44.6018H5.0123V18.1495ZM9.46621 5.39832C6.45771 5.39832 4.49219 7.37341 4.49219 9.9658C4.49219 12.5049 6.4002 14.5374 9.35117 14.5374H9.40723C12.4732 14.5374 14.3826 12.5048 14.3826 9.9658C14.3251 7.37341 12.4733 5.39832 9.46621 5.39832ZM35.3847 17.5281C30.7187 17.5281 28.6284 20.0945 27.4623 21.8943V18.1495H18.6695C18.7859 20.631 18.6695 44.6018 18.6695 44.6018H27.4623V29.829C27.4623 29.0378 27.5198 28.2495 27.7512 27.6827C28.3878 26.1032 29.8345 24.4676 32.2611 24.4676C35.4449 24.4676 36.7164 26.8944 36.7164 30.4488V44.6017H45.5078V29.4335C45.5078 21.3086 41.1717 17.5281 35.3847 17.5281Z"
      />
    </svg>
  );
};
const IconLuce: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M25 39.5834C23.8334 39.5834 22.9167 40.5209 22.9167 41.6667V43.75C22.9167 44.8959 23.8542 45.8334 25 45.8334C26.1459 45.8334 27.0834 44.8959 27.0834 43.75V41.6667C27.0834 40.5209 26.1459 39.5834 25 39.5834Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M12.4792 35.6042L11 37.0834C10.1875 37.8959 10.1875 39.2084 11 40.0209C11.8125 40.8334 13.125 40.8334 13.9375 40.0209L15.4167 38.5417C16.2292 37.7292 16.2292 36.4167 15.4167 35.6042C14.625 34.8126 13.2917 34.8126 12.4792 35.6042Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M10.4167 25C10.4167 23.8541 9.47919 22.9166 8.33335 22.9166H6.25002C5.10419 22.9166 4.16669 23.8541 4.16669 25C4.16669 26.1458 5.10419 27.0833 6.25002 27.0833H8.33335C9.47919 27.0833 10.4167 26.1458 10.4167 25Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M43.75 22.9166H41.6666C40.5208 22.9166 39.5833 23.8541 39.5833 25C39.5833 26.1458 40.5208 27.0833 41.6666 27.0833H43.75C44.8958 27.0833 45.8333 26.1458 45.8333 25C45.8333 23.8541 44.8958 22.9166 43.75 22.9166Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M37.5208 35.6041C36.7083 34.7916 35.3958 34.7916 34.5833 35.6041C33.7708 36.4166 33.7708 37.7291 34.5833 38.5416L36.0625 40.0208C36.875 40.8333 38.1875 40.8333 39 40.0208C39.8125 39.2083 39.8125 37.8958 39 37.0833L37.5208 35.6041Z"
      />
      <path
        fill={fill || DEFAULT_COLOR}
        d="M31.25 16.7083V10.4167C31.25 8.125 29.375 6.25 27.0834 6.25H22.9167C20.625 6.25 18.75 8.125 18.75 10.4167V16.7083C15.7709 18.9583 14 22.75 14.7709 26.9375C15.5209 31 18.7292 34.3333 22.7709 35.1667C29.5 36.5833 35.4167 31.4792 35.4167 25C35.4167 21.6042 33.7709 18.625 31.25 16.7083ZM27.0834 14.7917C26.4167 14.6667 25.7084 14.5833 25 14.5833C24.2917 14.5833 23.5834 14.6667 22.9167 14.7917V10.4167H27.0834V14.7917Z"
      />
    </svg>
  );
};
const IconMenu: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M8.08333 38H41.4167C42.5625 38 43.5 37.0625 43.5 35.9167C43.5 34.7708 42.5625 33.8333 41.4167 33.8333H8.08333C6.9375 33.8333 6 34.7708 6 35.9167C6 37.0625 6.9375 38 8.08333 38ZM8.08333 27.5833H41.4167C42.5625 27.5833 43.5 26.6458 43.5 25.5C43.5 24.3542 42.5625 23.4167 41.4167 23.4167H8.08333C6.9375 23.4167 6 24.3542 6 25.5C6 26.6458 6.9375 27.5833 8.08333 27.5833ZM6 15.0833C6 16.2292 6.9375 17.1667 8.08333 17.1667H41.4167C42.5625 17.1667 43.5 16.2292 43.5 15.0833C43.5 13.9375 42.5625 13 41.4167 13H8.08333C6.9375 13 6 13.9375 6 15.0833Z"
      />
    </svg>
  );
};
const IconPinterest: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.8761 17.9884C40.8761 27.2299 35.7383 34.1352 28.1644 34.1352C25.6199 34.1352 23.2287 32.7595 22.4092 31.1978C22.4092 31.1978 21.0409 36.6261 20.7527 37.674C19.7324 41.3759 16.7314 45.0792 16.4994 45.3836C16.3361 45.5945 15.978 45.5282 15.9394 45.249C15.8743 44.7772 15.1098 40.1061 16.0104 36.2953C16.4619 34.3818 19.0402 23.4578 19.0402 23.4578C19.0402 23.4578 18.2892 21.9535 18.2892 19.7308C18.2892 16.2382 20.3123 13.6325 22.8321 13.6325C24.9748 13.6325 26.009 15.2403 26.009 17.1687C26.009 19.324 24.6382 22.5447 23.9298 25.5284C23.3384 28.0281 25.1832 30.0674 27.6479 30.0674C32.111 30.0674 35.1171 24.3333 35.1171 17.5403C35.1171 12.3776 31.6406 8.51211 25.3142 8.51211C18.1695 8.51211 13.7153 13.8419 13.7153 19.7955C13.7153 21.8486 14.3214 23.2969 15.2705 24.4156C15.7047 24.9307 15.7671 25.1378 15.6086 25.729C15.4938 26.1632 15.2368 27.206 15.1272 27.62C14.9712 28.2176 14.4871 28.4296 13.9485 28.2099C10.6579 26.8665 9.12366 23.2605 9.12366 19.2092C9.12395 12.5176 14.7681 4.49219 25.9617 4.49219C34.9574 4.49219 40.8761 10.9995 40.8761 17.9884Z"
      />
    </svg>
  );
};
const IconPrint: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M39.5833 16.6667H10.4167C6.95832 16.6667 4.16666 19.4583 4.16666 22.9167V31.25C4.16666 33.5417 6.04166 35.4167 8.33332 35.4167H12.5V39.5833C12.5 41.875 14.375 43.75 16.6667 43.75H33.3333C35.625 43.75 37.5 41.875 37.5 39.5833V35.4167H41.6667C43.9583 35.4167 45.8333 33.5417 45.8333 31.25V22.9167C45.8333 19.4583 43.0417 16.6667 39.5833 16.6667ZM31.25 39.5833H18.75C17.6042 39.5833 16.6667 38.6458 16.6667 37.5V29.1667H33.3333V37.5C33.3333 38.6458 32.3958 39.5833 31.25 39.5833ZM39.5833 25C38.4375 25 37.5 24.0625 37.5 22.9167C37.5 21.7708 38.4375 20.8333 39.5833 20.8333C40.7292 20.8333 41.6667 21.7708 41.6667 22.9167C41.6667 24.0625 40.7292 25 39.5833 25ZM35.4167 6.25H14.5833C13.4375 6.25 12.5 7.1875 12.5 8.33333V12.5C12.5 13.6458 13.4375 14.5833 14.5833 14.5833H35.4167C36.5625 14.5833 37.5 13.6458 37.5 12.5V8.33333C37.5 7.1875 36.5625 6.25 35.4167 6.25Z"
      />
    </svg>
  );
};
const IconRestart: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
<svg className="icon-restart" id="Componente_26_1" data-name="Componente 26 – 1" xmlns="http://www.w3.org/2000/svg"  width="85" height="95" viewBox="0 0 85 95">
  <circle className="circle" id="Ellisse_31" data-name="Ellisse 31" cx="27" cy="27" r="27" transform="translate(16 20)" fill="transparent"/>
  <g id="Raggruppa_856" data-name="Raggruppa 856" transform="translate(7.909 4.733)">
    <g id="Raggruppa_855" data-name="Raggruppa 855">
      <path id="Tracciato_1080" data-name="Tracciato 1080" d="M35.337,90.184a35.34,35.34,0,0,1-7.12-69.955.856.856,0,0,1,.343,1.677,33.656,33.656,0,1,0,6.777-.683.856.856,0,0,1,0-1.712,35.337,35.337,0,1,1,0,70.673" transform="translate(0 -12.829)" fill="#00ffba"/>
      <path id="Tracciato_1081" data-name="Tracciato 1081" d="M108.216,15.076a.854.854,0,0,1-.605-.251l-6.682-6.682a.856.856,0,0,1,0-1.211L107.611.25a.856.856,0,0,1,1.211,1.211l-6.077,6.077,6.077,6.077a.856.856,0,0,1-.606,1.462" transform="translate(-66.198 0)" fill="#00ffba"/>
      <path id="Tracciato_1082" data-name="Tracciato 1082" d="M101.535,91.2a.856.856,0,0,1-.856-.856V58.978a.856.856,0,1,1,1.712,0V90.341a.856.856,0,0,1-.856.856" transform="translate(-66.199 -38.216)" fill="#00ffba" className="vertline"/>
    </g>
  </g>
</svg>

  );
};
const IconSend: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M7.08334 42.5001L43.4375 26.9167C45.125 26.1876 45.125 23.8126 43.4375 23.0834L7.08334 7.50008C5.70834 6.89591 4.18751 7.91674 4.18751 9.39591L4.16667 19.0001C4.16667 20.0417 4.9375 20.9376 5.97917 21.0626L35.4167 25.0001L5.97917 28.9167C4.9375 29.0626 4.16667 29.9584 4.16667 31.0001L4.18751 40.6042C4.18751 42.0834 5.70834 43.1042 7.08334 42.5001Z"
      />
    </svg>
  );
};
const IconSound: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M6.25 20.8333V29.1666C6.25 30.3124 7.1875 31.2499 8.33333 31.2499H14.5833L21.4375 38.1041C22.75 39.4166 25 38.4791 25 36.6249V13.3541C25 11.4999 22.75 10.5624 21.4375 11.8749L14.5833 18.7499H8.33333C7.1875 18.7499 6.25 19.6874 6.25 20.8333ZM34.375 24.9999C34.375 21.3124 32.25 18.1458 29.1667 16.6041V33.3749C32.25 31.8541 34.375 28.6874 34.375 24.9999ZM29.1667 9.27077V9.68743C29.1667 10.4791 29.6875 11.1666 30.4167 11.4583C35.7917 13.6041 39.5833 18.8749 39.5833 24.9999C39.5833 31.1249 35.7917 36.3958 30.4167 38.5416C29.6667 38.8333 29.1667 39.5208 29.1667 40.3124V40.7291C29.1667 42.0416 30.4792 42.9583 31.6875 42.4999C38.75 39.8124 43.75 32.9999 43.75 24.9999C43.75 16.9999 38.75 10.1874 31.6875 7.49993C30.4792 7.02077 29.1667 7.95827 29.1667 9.27077Z"
      />
    </svg>
  );
};
const IconYoutube: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      className={props.className}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill || DEFAULT_COLOR}
        d="M41.6694 27.8047C41.6694 25.1437 39.4843 22.9823 36.7901 22.9823C32.9458 22.8212 29.0128 22.7501 25.0002 22.7584C20.9878 22.7501 17.0534 22.8212 13.2091 22.9823C10.5161 22.9823 8.33101 25.1437 8.33101 27.8047C8.16871 29.9139 8.09889 32.0246 8.10484 34.1325C8.09889 36.2418 8.16881 38.3512 8.33101 40.4605C8.33101 43.1226 10.5161 45.284 13.2091 45.284C17.0535 45.4441 20.9878 45.515 25.0002 45.5079C29.0128 45.515 32.9457 45.4441 36.7901 45.284C39.4843 45.284 41.6694 43.1226 41.6694 40.4605C41.8316 38.3512 41.9016 36.2418 41.8944 34.1325C41.9016 32.0246 41.8316 29.9138 41.6694 27.8047ZM15.4203 41.3912H13.1121V28.6135H10.7234V26.444H17.8091V28.6135H15.4204V41.3912H15.4203ZM23.6324 41.3912H21.5823V40.175C21.2057 40.6239 20.8126 40.9649 20.4027 41.1991C19.9941 41.4339 19.5974 41.551 19.2125 41.551C18.7386 41.551 18.3823 41.3875 18.1419 41.0598C17.9015 40.7305 17.7806 40.2377 17.7806 39.5828V30.3652H19.8307V38.8176C19.8307 39.0793 19.8745 39.2689 19.9598 39.385C20.0462 39.5024 20.1848 39.5617 20.3767 39.5617C20.5284 39.5617 20.7189 39.4833 20.9487 39.3294C21.1785 39.1743 21.3904 38.9765 21.5823 38.736V30.3653H23.6324V41.3912ZM31.5235 39.1078C31.5235 39.8917 31.3635 40.4911 31.0438 40.908C30.7217 41.3237 30.2574 41.5322 29.65 41.5322C29.2497 41.5322 28.892 41.4518 28.5782 41.2893C28.2642 41.1283 27.9717 40.8807 27.703 40.5444V41.3913H25.6328V26.4441H27.703V31.257C27.9788 30.9197 28.2712 30.665 28.5828 30.4897C28.893 30.3146 29.2082 30.2267 29.5255 30.2267C30.1746 30.2267 30.6708 30.4623 31.0106 30.9326C31.353 31.4038 31.5235 32.0899 31.5235 32.9899V39.1078ZM39.1019 36.1376H35.1806V38.2173C35.1806 38.7976 35.2481 39.1991 35.3842 39.4239C35.5182 39.6491 35.7491 39.7603 36.0759 39.7603C36.4146 39.7603 36.6526 39.6656 36.7889 39.4748C36.924 39.2854 36.9915 38.8663 36.9915 38.2172V37.4507H39.1019V38.2798C39.1019 39.4096 38.8448 40.26 38.3308 40.8331C37.8169 41.4039 37.0506 41.6905 36.0286 41.6905C35.1119 41.6905 34.3894 41.3873 33.8612 40.7812C33.3354 40.1747 33.0702 39.341 33.0702 38.2797V33.3305C33.0702 32.3723 33.3603 31.593 33.9393 30.9904C34.5185 30.3876 35.267 30.0865 36.1836 30.0865C37.1226 30.0865 37.8417 30.366 38.3461 30.9227C38.8495 31.4818 39.1018 32.2835 39.1018 33.3304V36.1376H39.1019ZM26.0294 19.1072C25.7878 18.7779 25.6693 18.2864 25.6693 17.6303V8.41399H27.7182V16.8664C27.7182 17.1281 27.7608 17.3164 27.8472 17.4337C27.9336 17.5497 28.0722 17.609 28.2641 17.609C28.4157 17.609 28.6063 17.532 28.8361 17.3769C29.067 17.2218 29.2778 17.024 29.4698 16.7835V8.41399H31.5198V19.4399H29.4698V18.2225C29.0919 18.6713 28.6987 19.0124 28.2902 19.2481C27.8815 19.4814 27.4848 19.5998 27.101 19.5998C26.6262 19.5998 26.2699 19.4353 26.0294 19.1072ZM17.9772 16.6509C17.9772 17.5876 18.2472 18.3337 18.7849 18.8868C19.3225 19.4423 20.0402 19.7182 20.9368 19.7182C21.8688 19.7182 22.5995 19.4505 23.1314 18.9128C23.6631 18.3752 23.9284 17.6362 23.9284 16.6911V10.9969C23.9284 10.1561 23.6572 9.4679 23.116 8.93499C22.5735 8.40208 21.8795 8.1344 21.0304 8.1344C20.0984 8.1344 19.357 8.38782 18.8051 8.89475C18.2533 9.40051 17.9772 10.0802 17.9772 10.9341V16.6509ZM20.0866 10.8513C20.0866 10.6097 20.1659 10.4156 20.3211 10.2674C20.4786 10.1194 20.6811 10.0459 20.931 10.0459C21.2035 10.0459 21.4213 10.1194 21.5883 10.2674C21.7552 10.4155 21.8382 10.6096 21.8382 10.8513V16.857C21.8382 17.1531 21.7565 17.3864 21.5942 17.5545C21.4307 17.7239 21.2081 17.8079 20.9309 17.8079C20.6597 17.8079 20.4525 17.7262 20.3055 17.5604C20.1587 17.3946 20.0865 17.1601 20.0865 16.8569V10.8513H20.0866ZM29.1951 32.2673C29.3407 32.4602 29.4141 32.7421 29.4141 33.1139V38.8083C29.4141 39.1602 29.355 39.4123 29.2365 39.5687C29.1182 39.7225 28.9344 39.7996 28.6836 39.7996C28.5093 39.7996 28.3447 39.7604 28.1885 39.6811C28.0321 39.6018 27.8698 39.4724 27.703 39.2937V32.4224C27.8415 32.2706 27.9823 32.1582 28.1256 32.0861C28.269 32.0139 28.4123 31.9771 28.559 31.9771C28.8362 31.977 29.0481 32.074 29.1951 32.2673ZM36.7783 32.317C36.9204 32.517 36.9915 32.8488 36.9915 33.3096V34.425H35.1806V33.3096C35.1806 32.8488 35.2517 32.517 35.3938 32.317C35.5359 32.118 35.7704 32.0173 36.0961 32.0173C36.4087 32.0172 36.6361 32.118 36.7783 32.317ZM13.086 13.5172L10.3384 4.4928H12.6645L14.1626 10.4677H14.307L15.7365 4.4928H18.0814L15.3941 13.2377V19.44H13.086V13.5172Z"
      />
    </svg>
  );
};
const IconWarning: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 554.2 554.199"
      className={props.className}
      style={props.style}
    >
      <g>
        <path
          fill={fill || DEFAULT_COLOR}
          d="M538.5,386.199L356.5,70.8c-16.4-28.4-46.7-45.9-79.501-45.9c-32.8,0-63.1,17.5-79.5,45.9L12.3,391.6
		c-16.4,28.4-16.4,63.4,0,91.8C28.7,511.8,59,529.3,91.8,529.3H462.2c0.101,0,0.2,0,0.2,0c50.7,0,91.8-41.101,91.8-91.8
		C554.2,418.5,548.4,400.8,538.5,386.199z M316.3,416.899c0,21.7-16.7,38.3-39.2,38.3s-39.2-16.6-39.2-38.3V416
		c0-21.601,16.7-38.301,39.2-38.301S316.3,394.3,316.3,416V416.899z M317.2,158.7L297.8,328.1c-1.3,12.2-9.4,19.8-20.7,19.8
		s-19.4-7.7-20.7-19.8L237,158.6c-1.3-13.1,5.801-23,18-23H299.1C311.3,135.7,318.5,145.6,317.2,158.7z"
        />
      </g>
    </svg>
  );
};
const IconInfo: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={props.className} style={props.style}
    height="24px" viewBox="0 0 24 24" width="24px" fill="none">
      <path d="M0 0h24v24H0V0z" fill="none"/><path fill={fill || DEFAULT_COLOR} d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
  );
};

const IconLink: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
    <svg className={props.className} style={props.style} height="24px" viewBox="0 0 24 24" width="24px" fill="none" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
      <path fill={fill || DEFAULT_COLOR} d="M14.851 11.923c-.179-.641-.521-1.246-1.025-1.749-1.562-1.562-4.095-1.563-5.657 0l-4.998 4.998c-1.562 1.563-1.563 4.095 0 5.657 1.562 1.563 4.096 1.561 5.656 0l3.842-3.841.333.009c.404 0 .802-.04 1.189-.117l-4.657 4.656c-.975.976-2.255 1.464-3.535 1.464-1.28 0-2.56-.488-3.535-1.464-1.952-1.951-1.952-5.12 0-7.071l4.998-4.998c.975-.976 2.256-1.464 3.536-1.464 1.279 0 2.56.488 3.535 1.464.493.493.861 1.063 1.105 1.672l-.787.784zm-5.703.147c.178.643.521 1.25 1.026 1.756 1.562 1.563 4.096 1.561 5.656 0l4.999-4.998c1.563-1.562 1.563-4.095 0-5.657-1.562-1.562-4.095-1.563-5.657 0l-3.841 3.841-.333-.009c-.404 0-.802.04-1.189.117l4.656-4.656c.975-.976 2.256-1.464 3.536-1.464 1.279 0 2.56.488 3.535 1.464 1.951 1.951 1.951 5.119 0 7.071l-4.999 4.998c-.975.976-2.255 1.464-3.535 1.464-1.28 0-2.56-.488-3.535-1.464-.494-.495-.863-1.067-1.107-1.678l.788-.785z"/></svg>
  );
};

const IconSelected: FC<IIcon> = ({ fill, isSelected, ...props }: IIcon) => {
  return (
    <span className={`flex items-center justify-center ${isSelected ? "bg-fluo-effe" : "bg-transparent"} mr-2 xs:w-5 xs:h-5 md:w-8 md:h-8 ${props.className}}`} style={{ borderRadius:"50%",...props.style}}>
        <svg className={`${props.className} xs:scale-50 md:scale-100`} xmlns="http://www.w3.org/2000/svg" width="15.835" height="11.015" viewBox="0 0 15.835 11.015">
          <path id="Tracciato_1279" data-name="Tracciato 1279" d="M8616.814,675.664l5.173,5.173,9.955-9.954" transform="translate(-8616.461 -670.529)" fill="none" stroke="#6c6c6c" strokeWidth="1"/>
        </svg>
    </span>
  );
};

{/* <svg className={props.className} style={props.style}  xmlns="http://www.w3.org/2000/svg" width="60.876" height="76.303" viewBox="0 0 60.876 76.303">
  <path id="Tracciato_1085" data-name="Tracciato 1085" d="M10.494,1.753H40.921l14.13,14.13V61.777H44.032V27.929L28.874,12.772H10.494ZM8.743,0V14.525H28.15l14.13,14.13V63.53H56.8V15.156L41.646,0Z" transform="translate(4.071)" fill={fill}/>
  <path id="Tracciato_1086" data-name="Tracciato 1086" d="M1.715,10.5H31.509L45.347,24.626V70.52H1.715ZM0,8.744v63.53H47.06V23.9L32.218,8.744Z" transform="translate(0 4.029)" fill={fill}/>
  <path id="Tracciato_1119" data-name="Tracciato 1119" d="M19431.068,1917h24.863" transform="translate(-19419.568 -1874.852)" fill="none" stroke={fill} strokeWidth="1.6"/>
  <path id="Tracciato_1120" data-name="Tracciato 1120" d="M19431.068,1917h24.863" transform="translate(-19419.568 -1866.852)" fill="none" stroke={fill} strokeWidth="1.6"/>
  <path id="Tracciato_1121" data-name="Tracciato 1121" d="M19431.068,1917h24.863" transform="translate(-19419.568 -1858.852)" fill="none" stroke={fill} strokeWidth="1.6"/>
</svg> */}

const IconCopy: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
<svg className={`${props.className} icon-copy`} style={props.style} width="78" height="94" viewBox="0 0 78 94">
  <path className="back" id="Tracciato_1118" data-name="Tracciato 1118" d="M8979.758-661.934h12.8v-13h31.81l14.768,14.768v47.638h-13.405v12.319h-45.97Z" transform="translate(-8969 684)" fill="#00ffba"/>
  <path className="border" id="Tracciato_1084" data-name="Tracciato 1084" d="M32.171,2.911,43.824,14.562H32.171ZM30.42.8V15.437l.875.878H45.94l.619-1.5L31.914.175Z" transform="translate(23.818 8.42)" fill="#fff"/>
  <path className="border" id="Tracciato_1085" data-name="Tracciato 1085" d="M10.494,1.753H40.921l14.13,14.13V61.777H44.032V27.929L28.874,12.772H10.494ZM8.743,0V14.525H28.15l14.13,14.13V63.53H56.8V15.156L41.646,0Z" transform="translate(13.829 8.34)" fill="#fff"/>
  <path className="border" id="Tracciato_1086" data-name="Tracciato 1086" d="M1.751,10.5H32.178L46.31,24.626V70.52H1.751ZM0,8.744v63.53H48.06V23.9L32.9,8.744Z" transform="translate(9.758 12.369)" fill="#fff"/>
  <path className="stoke" id="Tracciato_1119" data-name="Tracciato 1119" d="M19431.068,1917h24.863" transform="translate(-19409.811 -1866.512)" fill="none" stroke="#fff" strokeWidth="1.6"/>
  <path className="stoke" id="Tracciato_1120" data-name="Tracciato 1120" d="M19431.068,1917h24.863" transform="translate(-19409.811 -1858.512)" fill="none" stroke="#fff" strokeWidth="1.6"/>
  <path className="stoke" id="Tracciato_1121" data-name="Tracciato 1121" d="M19431.068,1917h24.863" transform="translate(-19409.811 -1850.512)" fill="none" stroke="#fff" strokeWidth="1.6"/>
  <path className="border" id="Tracciato_1087" data-name="Tracciato 1087" d="M37.2,25.058H22.552l-.875-.876V9.538l1.494-.619L37.816,23.562ZM23.428,23.3H35.081L23.428,11.654Z" transform="translate(19.789 12.449)" fill="#fff"/>
</svg>


  );
};


const IconDownload: FC<IIcon> = ({ fill, ...props }: IIcon) => {
  return (
<svg className={`${props.className} icon-download`} style={props.style} viewBox="0 0 90 90" width="90" height="90">
		<g id="icona_download">
			<g id="Raggruppa_219">
				<g id="Raggruppa_15">
					<path id="Tracciato_11" fill="none" stroke={fill} strokeWidth="1" d="m66.8 38.5l-19.3 17.9-19.4-17.9"/>
				</g>
				<g id="Raggruppa_16">
					<path id="Tracciato_12" fill="none" stroke={fill} strokeWidth="1" d="m47.4 55.9v-49.9"/>
				</g>
			</g>
			<path id="Tracciato_13" fill="none"  d="m4 20h82v76h-82z"/>
			<path id="Tracciato_145" fill="none" stroke={fill} strokeWidth="1" d="m83.2 49.8c-0.2 8.8-4 17.1-10.7 23.3-6.8 6.1-15.9 9.5-25.3 9.5-9.5 0-18.6-3.4-25.3-9.5-6.8-6.2-10.6-14.5-10.7-23.3"/>
		</g>
</svg>
  );
};

const IconAccordionClosed: FC<IIcon> = ({ }: IIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="1" viewBox="0 0 20 1">
      <g id="Raggruppa_804" data-name="Raggruppa 804" transform="translate(0 -9.5)">
        <path id="Tracciato_805" data-name="Tracciato 805" d="M0,0V20" transform="translate(20 10) rotate(90)" fill="none" stroke="#fff" strokeWidth="1" />
      </g>
    </svg>
  );
};
const IconAccordionOpened: FC<IIcon> = ({ }: IIcon) => {
  return (
    <svg id="Raggruppa_803" data-name="Raggruppa 803" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path id="Tracciato_804" data-name="Tracciato 804" d="M10882.131,545.5v20" transform="translate(-10872.131 -545.5)" fill="none" stroke="#fff" strokeWidth="1" />
      <path id="Tracciato_805" data-name="Tracciato 805" d="M0,0V20" transform="translate(20 10) rotate(90)" fill="none" stroke="#fff" strokeWidth="1" />
    </svg>
  );
};

export {
  IconSelected,
  IconClose,
  IconCloseMenu,
  IconDomotica,
  IconEdit,
  IconFacebook,
  IconFrecciaDx,
  IconFrecciaDown,
  IconFrecciaUp,
  IconFrecciaSx,
  IconInstagram,
  IconLinkedin,
  IconLuce,
  IconMenu,
  IconPinterest,
  IconPrint,
  IconRestart,
  IconSend,
  IconSound,
  IconYoutube,
  IconFrecciaDownNext,
  IconWarning,
  IconInfo,
  IconLink,
  IconCopy,
  IconDownload,
  IconAccordionClosed,
  IconAccordionOpened
};
